import React from 'react';

const LabeledListTitle = ({ title }: { title: string | undefined }) => {
    if (!title) return null;
    return <h3 className="mt-6 mb-4 text-lg font-bold text-gray-800">{title}</h3>;
};

export default LabeledListTitle;
